import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "relative w-full flex space-x-2" }
const _hoisted_2 = { class: "flex flex-col items-center left-0 top-0 bottom-0 w-4" }
const _hoisted_3 = { class: "relative mt-1 mb-3 h-4 w-4 flex items-center justify-center flex-shrink-0" }
const _hoisted_4 = {
  key: 0,
  class: "animate-ping absolute block inset-0 rounded-full bg-blue/50"
}
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = { class: "flex items-center space-x-2" }
const _hoisted_7 = { class: "title-3 !mb-0 inline-block !text-left" }
const _hoisted_8 = { class: "inline-flex rounded-lg items-center justify-center px-2 py-1 bg-neutral-800 text-xs whitespace-nowrap font-semibold" }
const _hoisted_9 = { class: "block" }
const _hoisted_10 = { class: "pb-12 pt-3" }

import { computed } from "vue";
// import { CheckIcon, XMarkIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressItem',
  props: [
    "title",
    "subtitle",
    "isCurrent",
    "isActive",
    "tag",
    "isLast",
],
  setup(__props) {

const props = __props



const classes = computed(() => {
    return {
        "!bg-green-600 !text-neutral-50": !!props.isCurrent,
    };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        (__props.isCurrent)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass(["relative block h-2 w-2 rounded-full", [
                        __props.isActive || __props.isCurrent ? 'bg-blue' : 'bg-neutral-400/50',
                    ]])
        }, null, 2)
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["block flex-1 w-px", [
                    __props.isLast
                        ? 'bg-neutral-400/0'
                        : __props.isActive || __props.isCurrent
                        ? 'bg-blue'
                        : 'bg-neutral-400/25',
                ]])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h4", _hoisted_7, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(__props.tag), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})